import React from 'react';
import { CheckIcon, BellIcon, BanIcon, XIcon } from 'lucide-react';
import type { SoundId } from '../../types/anna';
interface ToastProps {
  tone: SoundId;
  title: string;
  detail?: string;
  onClose?: () => void;
  size?: 'sm' | 'wall';
}
const toneStyle: Record<SoundId, {
  icon: typeof CheckIcon;
  className: string;
}> = {
  klaar: {
    icon: CheckIcon,
    className: 'bg-accent/15 text-accent'
  },
  meldt: {
    icon: BellIcon,
    className: 'bg-white/10 text-ink'
  },
  geweigerd: {
    icon: BanIcon,
    className: 'bg-amber/15 text-amber'
  }
};
export function Toast({
  tone,
  title,
  detail,
  onClose,
  size = 'sm'
}: ToastProps) {
  const {
    icon: Icon,
    className
  } = toneStyle[tone];
  const wall = size === 'wall';
  return <div role="status" className={`glass flex w-full items-start gap-3 rounded-2xl ${wall ? 'max-w-[560px] px-5 py-4' : 'max-w-[380px] px-4 py-3.5'}`} data-id="element-1383" data-mp="1u055twr97rmp">
      <span className={`grid shrink-0 place-items-center rounded-full ${wall ? 'h-11 w-11' : 'h-8 w-8'} ${className}`} data-id="element-1384" data-mp="11cshbh1j99qr">
        <Icon className={wall ? 'h-5 w-5' : 'h-4 w-4'} strokeWidth={2} aria-hidden data-id="element-1385" data-mp="do9psse6u67j" />
      </span>
      <div className="min-w-0 flex-1 self-center" data-id="element-1386" data-mp="ilt57vmmgp12">
        <p className={`font-semibold text-ink ${wall ? 'text-[22px]' : 'text-[15px]'}`} data-id="element-1387" data-mp="iki5c6was1f8">{title}</p>
        {detail && <p className={`leading-snug text-ink-soft ${wall ? 'text-[22px]' : 'text-[14px]'}`} data-id="element-1388" data-mp="scedybw0f9xp">{detail}</p>}
      </div>
      {onClose && <button type="button" onClick={onClose} aria-label="Melding sluiten" className={`grid shrink-0 place-items-center rounded-full text-ink-muted transition-colors duration-150 hover:bg-white/10 hover:text-ink ${wall ? 'h-11 w-11' : 'h-7 w-7'}`} data-id="element-1389" data-mp="3qutawi94fgi8">
          <XIcon className={wall ? 'h-5 w-5' : 'h-4 w-4'} data-id="element-1390" data-mp="8pyh4kzmq1qw" />
        </button>}
    </div>;
}